import { render, staticRenderFns } from "./ShowCredentialPuntosColombia.vue?vue&type=template&id=94b77a3e"
import script from "./ShowCredentialPuntosColombia.vue?vue&type=script&lang=js"
export * from "./ShowCredentialPuntosColombia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports